module.exports = __webpack_public_path__ + "static/media/neutral.cd9a0245.svg";